import { HookType } from '@rossum/api-client/hooks';
import CodeTagsIcon from 'mdi-react/CodeTagsIcon';
import WebhookIcon from 'mdi-react/WebhookIcon';
import { LocalizationKeys } from '../../../../../i18n';

type ConfigOption = {
  icon: JSX.Element;
  translation: LocalizationKeys;
};

// we allow to create only webhooks and functions for now
export type CreatableHookType = Extract<HookType, 'webhook' | 'function'>;

type ExtensionTypeConfig = Record<CreatableHookType, ConfigOption>;

export const extensionTypeConfig: ExtensionTypeConfig = {
  webhook: {
    icon: <WebhookIcon />,
    translation:
      'containers.settings.extensions.createExtension.extensionType.webhook.label',
  },
  function: {
    icon: <CodeTagsIcon />,
    translation:
      'containers.settings.extensions.createExtension.extensionType.function.label',
  },
};
